// Settings configured here will be merged into the final config object.
export default {
  articleId: '13232179'
}
